module.exports = __webpack_public_path__ + "static/media/pause-icon.1917f711.svg";